module.exports = __webpack_public_path__ + "img/undraw_Timeline_re_aw6g.6d0384db.svg";